import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toRefs } from 'vue';
const __default__ = {
  name: 'XIcon'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    icon: {
      type: String,
      default: ''
    },
    rotate: {
      type: Number,
      default: 0
    },
    spin: {
      type: Boolean,
      default: false
    },
    iconStyle: {
      type: Object,
      default: () => ({
        size: '12px'
      })
    }
  },
  setup(__props) {
    const props = __props;
    const {
      icon,
      rotate,
      spin
    } = toRefs(props);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon)), {
        style: _normalizeStyle(__props.iconStyle),
        spin: _unref(spin),
        rotate: _unref(rotate)
      }, null, 8, ["style", "spin", "rotate"]);
    };
  }
});